/**
 * API may return a single address (save with get_only_default_address) or an array.
 * Redux and list UIs always expect an array.
 */
export function normalizeAddresses(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && typeof data === "object" && data.id != null) {
    return [data];
  }
  return [];
}

export function pickDefaultAddress(addresses, defaultAddressId) {
  const list = normalizeAddresses(addresses);
  if (list.length === 0) {
    return null;
  }
  if (defaultAddressId != null) {
    return list.find((a) => a.id === defaultAddressId) || list[0];
  }
  return list[0];
}
